import React from 'react';
import { Global } from '@emotion/core';
import { Flex, Image, LoadingIndicator } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';

import Portal from '@shared/v2/components/Portal';

import roo from './assets/roo.svg';

/**
 * @param {{ children: React.ReactNode }} props
 */
const LoadingOverlay = ({ children }) => (
  <Portal selector="portal-root">
    <Global
      styles={{
        body: {
          overflow: 'hidden',
        },
      }}
    />
    <Flex
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      py={[0, null, 10]}
      position="fixed"
      zIndex="popup"
      top="0"
      bottom="0"
      right="0"
      left="0"
      bg="white"
      textAlign="center"
      px="4"
    >
      <Image height="55px" src={roo} alt="Qantas Hotels" />
      {children}
      <LoadingIndicator />
    </Flex>
  </Portal>
);

LoadingOverlay.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LoadingOverlay;
